const PITCHLANE_COOKIE_DOMAIN = ".pitchlane.com"

export function getConsentCookieDomain(hostname = window.location.hostname): string {
    if (hostname === "pitchlane.com" || hostname.endsWith(".pitchlane.com")) {
        return PITCHLANE_COOKIE_DOMAIN
    }

    return hostname
}
